export const FilterIcon = (props) => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 2.66649H11"
        stroke="#262626"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 7.11115H11"
        stroke="#262626"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.33317 4.33333C5.25365 4.33333 5.99984 3.58714 5.99984 2.66667C5.99984 1.74619 5.25365 1 4.33317 1C3.4127 1 2.6665 1.74619 2.6665 2.66667C2.6665 3.58714 3.4127 4.33333 4.33317 4.33333Z"
        fill="#F9F9F9"
        stroke="#262626"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.66667 8.77747C8.58714 8.77747 9.33333 8.03128 9.33333 7.1108C9.33333 6.19033 8.58714 5.44414 7.66667 5.44414C6.74619 5.44414 6 6.19033 6 7.1108C6 8.03128 6.74619 8.77747 7.66667 8.77747Z"
        fill="#F9F9F9"
        stroke="#262626"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
